import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanMentorsProvider = {
  getAllMentors(params = {}) {
    return api.post(`${baseUrl}/MentorTable`, {
      params,
    })
  },

  getMentor(params) {
    return api.get(`${baseUrl}/EditMentor/${params}`)
  },

  addMentor(params) {
    return api.post(`${baseUrl}/Mentor`, params)
  },

  updateMentor(params = {}) {
    return api.put(`${baseUrl}/Mentor`, params)
  },

  deleteMentor(params) {
    return api.delete(`${baseUrl}/Mentor/${params}`)
  },
}

export default dadbanMentorsProvider
